
export const categories = [
  {
    key: 'Header',
    value: 'Header',
    text: 'Header'
  },
  {
    key: 'Footer',
    value: 'Footer',
    text: 'Footer'
  },
  {
    key: 'CTA',
    value: 'CTA',
    text: 'Call to Action'
  },
  {
    key: 'Video',
    value: 'Video',
    text: 'Video'
  },
  {
    key: 'Demo',
    value: 'Demo',
    text: 'Demo'
  }
]
